import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { mapState, mapActions } from "vuex";

import VueApexCharts from 'vue-apexcharts';
Vue.component('apexchart', VueApexCharts);

Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
  VueApexCharts,
  router,
  store,
  vuetify,
    computed: {
    ...mapState(["settings"])
  },
  methods: {
    ...mapActions(["setOnlineStatusInStore", "initializeStore"]),
    onlineStatusChanged() {
      this.setOnlineStatusInStore(navigator.onLine);
    }, 
    showNoticeError(text) {
      window.dispatchEvent(new CustomEvent('tdm-show-notice', {
        detail:{text: text, on: true, color: 'error'}
      }));
    },
    showNoticeInfo(text) {
      window.dispatchEvent(new CustomEvent('tdm-show-notice', {
        detail: {text: text, on: true, color: 'info'}
      }));
    },
    showNoticeSuccess(text) {
      window.dispatchEvent(new CustomEvent('tdm-show-notice', {
          detail: {text: text, on: true, color: 'success'}
      }));
    },
    showInProgress(enabled) {
      window.dispatchEvent(new CustomEvent('tdm-show-in-progress', {
          detail: {enabled: enabled}
      }));
    },
  },
  render: h => h(App),
  async created() {
    try {
      window.addEventListener("online", this.onlineStatusChanged);
      window.addEventListener("offline", this.onlineStatusChanged);

      await this.initializeStore();
      this.$mount("#app");
      this.$root.showInProgress(false);
    }
    catch (error) {
      var msg = `Get Tablet List API failed. ${error}`;
      this.$root.showInProgress(false);
      this.showNoticeError(msg);
    }
    this.$vuetify.theme.dark = this.settings.isDarkMode;
  },
  beforeDestroyed() {
    window.removeEventListener("online", this.onlineStatusChanged);
    window.removeEventListener("offline", this.onlineStatusChanged);
  },
});